export class CompanyBasedSectionReports {
    private _allReports: string[] = [];
    private _patternReports: string[] = [];

    constructor(allReports: string[], patternReports: string[]) {
        this._allReports = allReports;
        this._patternReports = patternReports;
    }

    /* all reports available in section */
    get allReports() {
        return this._allReports;
    }

    /* reports to be taken into account when creating filtering configuration for whole section */
    get patternReports() {
        return this._patternReports;
    }
}
